module.exports = __webpack_public_path__ + "static/img/4dx-new.2fecacd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4dx-new.svg
// module id = 586
// module chunks = 1